import React from 'react';
import { Link } from 'react-router-dom';
import { PageWrapper } from './../../components';
import { heights, widths, fonts } from './../../styles/theme.json';
import bgImage from '../../scripts/bg-image';

const big_space = '9.5rem';

const GalleryList = (props) => {
  const Galleries = props.data.gallery_list.map((item, i) =>
    <li className={'gallery'} key={'gallery-' + i}>
      <h2 className={'medium-header gallery-title'}>{item.gallery_name}</h2>
      <p dangerouslySetInnerHTML={{__html:item.gallery_address}}/>
      <p>{item.gallery_phone}</p>
      <p><a className='external-link-lg' href={item.gallery_url} target='_blank'>{item.gallery_url}</a></p>
      <style jsx>{`
        .gallery {
          margin-bottom: ${big_space};
        }
        .gallery-title {
          margin-bottom: ${widths.single_pad};
        }
        p {
          line-height: 1.5;
          font-size: 1.4rem;
        }
      `}</style>
    </li>
  );
  const Contacts = props.data.inquiries_contacts.map((item, i) =>
    <li className={'contact-li'} key={'gallery-' + i}>
      <p>{item.name}</p>
      <p><a className={'external-link-lg'} href={item.email} target={'_blank'}>{item.email}</a></p>
      <style jsx>{`
        p {
          line-height: 1.45;
          font-size: 1.4rem;
        }
      `}</style>
    </li>
  );
  return (
    <PageWrapper pageId={'gallery-list'}>
      <section id={'gallery-list'}>
        <ul id={'galleries'}>
          {Galleries}
        </ul>
        <div className={'info'} dangerouslySetInnerHTML={{__html:props.data.additional_inquiries_message}}/>
        <ul id={'contacts'}>
          {Contacts}
        </ul>
        <div className={'back'}>
          <Link className={'bold-small-link'} to={'/fine-art'}>
            <span className={'back-arrow'} style={bgImage('/static/icons/back-arrow.png')}/>
            <span>{'Back to Exhibitions'}</span>
          </Link>
        </div>
      </section>
      <style jsx>{`
        #gallery-list {
          margin-top: ${heights.header};
          max-width: ${widths.global_max_width};
          text-align: center;
          padding: 5rem 2.5rem;
          display: flex;
          flex-direction: column;
          min-height: calc(100vh - 12rem);
        }
        #galleries,
        #contacts {
          list-style: none;
          width: 100%;
        }
        #contacts {
          margin-bottom: ${big_space};
        }
        .info {
          margin: 0 auto .5rem;
          max-width: 28rem;
        }
        @media (min-width: 640px) {
          .info {
            margin: 0 auto 1.25rem;
            max-width: 100%;
          }
        }
      `}</style>
    </PageWrapper>
  );
};

export default GalleryList;



// WEBPACK FOOTER //
// ./src/pages/ex-pub-gallery/GalleryList.js